import React,{useState} from "react";
import { Modal } from "../CustomModal/Modal";

//css
import "./ShowDemoData.scss";

//constants
import { Strings } from "../../Resources/Strings/i18n";
import { PATHS } from ".././../Constants";

//resources
import AllWellLogoImg from "../../Resources/Images/img_logo.png";
import Button from "@material-ui/core/Button";
import { Divider } from "@material-ui/core";
import img_demo_data_desktop from "../../Resources/Images/img_demo_data_desktop.png"
import img_demo_data_mobile from "../../Resources/Images/img_demo_data_mobile.png"

function ShowDemoData(props) {
  const [showDemoError, setShowDemoError] = useState(false)
  let hideModal = () => {
    setShowDemoError(false)
  }
  return (
    <div className="showDemoData">
      {/* error modal */}
      <div>
          {showDemoError ? (
            <Modal
              show={showDemoError}
             handleClose={hideModal}
              parent={"login"}
            >
              {
                <div>
                  <div className="errorOtp">
                    <div className="errorModal">
                      <div className="modalTitle">
                        <p id="errorTitle">
                          <span id="errorText">{Strings("ActionNotAvailable")}</span>
                        </p>
                      </div>
                      <div className="errorContainer">
                      <div className="errorContent">
                          <p>{Strings("ActionNotAvailableInfo")}</p>
                        </div>
                      </div>
                      <Button
                        className="errorBtn"
                        onClick={() => {
                         setShowDemoError(false)
                        }}
                      >
                       
                        {Strings("OK")}
                      </Button>
                    </div>
                  </div>
                </div>
              }
            </Modal>
          ) : null}
        </div>
      

      <div className="TopNavigationBar">
        <div>
          <div className="navbarTop">
            <div className="navbarContent">
              <div className="leftData">
                <div className="imgContent">
                  <img
                    className="logoImg"
                    src={AllWellLogoImg}
                    alt="All Well"
                  />
                </div>
                <Divider orientation="vertical" flexItem />
                <div className="infoText">{Strings("DemoData")}</div>
              </div>

              <div className="rightData">
                <div className="showDemoSignUpLogIn">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={() => props.history.push(PATHS.LOGIN)}
                  >
                    <div>{Strings("SignUpLogIn")}</div>
                  </Button>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="demoDataDesktop">
        <img src={img_demo_data_desktop} alt={"img_demo_data_desktop"} onClick={()=>setShowDemoError(true)}/>
      </div>
      <div className="demoDataMobile">
        <img src={img_demo_data_mobile} alt={"img_demo_data_desktop"} onClick={()=>setShowDemoError(true)}/>
   </div>
    </div>
  );
}

export default ShowDemoData;
















   